import * as React from "react";
function CloseCircleFillIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0m5.49 16.076a1 1 0 1 1-1.414 1.414l-3.9-3.9a.25.25 0 0 0-.354 0l-3.9 3.9a1.01 1.01 0 0 1-1.414 0 1 1 0 0 1 0-1.414l3.9-3.9a.25.25 0 0 0 0-.352v-.001l-3.9-3.9A1 1 0 1 1 7.924 6.51l3.9 3.9a.25.25 0 0 0 .354 0l3.9-3.9a1 1 0 1 1 1.412 1.414l-3.9 3.9a.25.25 0 0 0 0 .352v.001z"
  }));
}
export default CloseCircleFillIcon;